export var Side;
(function (Side) {
    Side["left"] = "left";
    Side["right"] = "right";
})(Side || (Side = {}));
export var Direction;
(function (Direction) {
    Direction["up"] = "up";
    Direction["down"] = "down";
    Direction["left"] = "left";
    Direction["right"] = "right";
})(Direction || (Direction = {}));
//# sourceMappingURL=index.js.map